import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			position: 'fixed',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
			display: 'flex',
			flex: 1,
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
		},
		loginBackground: {
			background: theme.palette.primary.main,
		},
		signUpBackground: {
			background: theme.palette.action.active,
		},
		temporaryUserMessage: {
			color: 'rgba(255, 255, 255, 0.7)',
			fontSize: 18,
			fontWeight: 300,
			[theme.breakpoints.down('xs')]: {
				fontSize: 14
			},
		},
		overlay: {
			background:
				'linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.2) 100%)',
			position: 'absolute',
			flex: 1,
			width: '100%',
			height: '100%',
		},
		logo: {
			margin: 'auto',
			width: '50%',
			textAlign: 'center',
			'& path': {
				stroke: 'rgba(255, 255, 255, 1)',
				strokeWidth: 3,
			},
		},
		logoText: {
			color: '#ffffff',
			fontSize: '20px',
			zIndex: 1,
		},
		labelFocus: {
			color: 'rgba(255, 255, 255, 0.8)!important',
		},
		closeButton: {
			zIndex: 1000,
			position: 'absolute',
			top: 0,
			right: 0,
			'& svg': {
				width: 42,
				height: 42,
				'& path:not(:first-child)': {
					fill: 'rgba(255, 255, 255, 0.5)',
				},
			},
		},
		avatar: {
			width: 100,
			height: 100,
			alignSelf: 'center',
			margin: 'auto',
			borderRadius: 50,
			border: '1px solid #fff',
			background: 'rgba(0, 0, 0, 0.4)',
			padding: 2,
			display: 'flex',
			backgroundSize: 'auto',
			backgroundPosition: 'center',
		},
	})
